// If a month/tag change is currently animating, ask useHotspotFilter.js's
// registered settle function (see AnimationContext's settleRef) to quickly
// bring things to rest before running the action, instead of dropping the
// click outright. Falls back to running immediately if nothing's animating,
// or if settleRef hasn't registered a settle function yet (e.g. very first
// render).
const settleOrRun = (isAnimating, settleRef, action) => {
  if (isAnimating && settleRef && settleRef.current) {
    settleRef.current(action);
  } else {
    action();
  }
};

export default settleOrRun;
